import React, { Component } from 'react'
import Breadcrumb from 'molecules/Breadcrumb'
import { toggleIsLoading } from 'Redux/actions/ViewStateActions'
import { setLocalSettingsTableData } from 'Redux/actions/SettingsTableActions'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { Footer, PageWrapper } from './styles'
import { withRouter } from 'react-router'
import { withTheme } from 'styled-components'
import Header from 'organisms/StockOpnameForm/Header'
import { permissionCheck } from 'helpers/permissionCheckHelper'
import {
  stockOpnameCreate,
  stockOpnameDelete,
  stockOpnameUpdate,
} from 'fixtures/permissions'
import lo, { isEqual } from 'lodash'
import { NewStockOpname } from 'fixtures/TemplateData'
import ButtonReg from 'components/atoms/Buttons/Button'
import DetailCoalInventory from 'components/organisms/StockOpnameForm/DetailCoalInventory'
import moment from 'moment'
import { getAllList, postNewData } from 'services/cmsService'
import { COAl_STOCK_INVENTORIES } from 'fixtures/api'
import { getAllProductsData } from 'Redux/actions/ProductActions'
import { getAllDirLocationsData } from 'Redux/actions/AreaActions'
import { formattedNumber } from 'helpers/numberHelper'

export class StockOpnameForm extends Component {
  constructor(props) {
    super(props)
    this.state = {
      form: lo.cloneDeep(NewStockOpname),
      allowCreate: false,
      allowDelete: false,
      allowUpdate: false,
      id: null,
      currentDetail: {},
    }
  }

  componentDidMount() {
    this.checkPermission()
    this.getId()
    this.fetchDetail()
  }

  componentDidUpdate(prevProps) {
    const { userLogin } = this.props
    if (prevProps.userLogin !== userLogin) {
      this.checkPermission()
    }
  }

  checkPermission() {
    const { userLogin } = this.props
    if (userLogin && userLogin.userDetail) {
      const {
        userDetail: { permissions },
      } = userLogin
      this.setState({
        allowCreate: permissionCheck(permissions, stockOpnameCreate),
        allowDelete: permissionCheck(permissions, stockOpnameDelete),
        allowUpdate: permissionCheck(permissions, stockOpnameUpdate),
      })
    }
  }

  getId() {
    const {
      match: { params },
    } = this.props
    if (params && params.id) {
      this.setState({ id: params.id })
    }
  }

  fetchDetail = async () => {
    const { toggleIsLoading } = this.props

    try {
      toggleIsLoading(true)
      const {
        match: { params },
      } = this.props
      if (params && params.id) {
        const dataApi = await getAllList(
          `${COAl_STOCK_INVENTORIES}/${params.id}`
        )

        const { createdAt, createdBy, updatedAt, updatedBy, ...data } = dataApi

        const mappingDetail = {
          ...data,
          areaCode: {
            code: data.areaCode,
          },
          period: moment(new Date(data.period)).format('YYYY-MM-DDTHH:mm:ssZ'),
          surveyDate: moment(new Date(data.surveyDate)).format(
            'YYYY-MM-DDTHH:mm:ssZ'
          ),
          coalStockInventoryDetails: data.coalStockInventoryDetails.map(
            ({ ...dataCoal }) => ({
              ...dataCoal,
              productCode: {
                name: dataCoal.productName || null,
              },
              dirLocationCode: {
                name: dataCoal.dirLocationCode || null,
              },
              startTime: moment(dataCoal.startTime, 'HH:mm:ss').format(
                'YYYY-MM-DDTHH:mm:ssZ'
              ),
              endTime: moment(dataCoal.endTime, 'HH:mm:ss').format(
                'YYYY-MM-DDTHH:mm:ssZ'
              ),
              tonnage: formattedNumber(dataCoal.tonnage),
              volume: formattedNumber(dataCoal.volume),
              factorScale: formattedNumber(dataCoal.factorScale),
            })
          ),
        }

        this.setState({
          form: {
            ...this.state.form,
            ...mappingDetail,
          },
        })

        this.setState({
          currentDetail: {
            ...mappingDetail,
          },
        })

        setTimeout(() => {
          this.setState({
            form: {
              ...this.state.form,
              surveyDate: moment(new Date(data.surveyDate), 'HH:mm:ss').format(
                'YYYY-MM-DDTHH:mm:ssZ'
              ),
            },
          })
        }, 500)
      }
    } catch (error) {
      return
    } finally {
      toggleIsLoading(false)
    }
  }

  onChange = (key, val) => {
    const form = lo.cloneDeep(this.state.form)
    form[key] = val
    this.setState({ form })
  }

  onChangeForm = (form) => {
    this.setState({ form })
  }

  validateSubmit = (form) => {
    const errors = []
    const requiredFields = [
      {
        key: 'companyCode',
        label: 'Company',
      },
      {
        key: 'period',
        label: 'Periode',
      },
      {
        key: 'surveyDate',
        label: 'Survey Date',
      },
      {
        key: 'coalStockInventoryDetails',
        label: 'Coal Detail',
      },
    ]

    if (form.companyCode === '-') {
      errors.push('- Company is required.')
    }

    for (const field of requiredFields) {
      if (form[field.key] === null || form[field.key] === '') {
        errors.push(`- ${field.label} is required.`)
      }

      if (Array.isArray(form[field.key]) && !form[field.key].length) {
        errors.push(`- ${field.label} cannot be empty.`)
      }
    }

    return errors
  }

  validateCancel = (form) => {
    let hasValues = false

    for (const key in form) {
      if (form.hasOwnProperty(key)) {
        const value = form[key]

        if (Array.isArray(value) && value.length) {
          hasValues = true
        }

        if (!Array.isArray(value) && value !== '-' && value) {
          hasValues = true
        }
      }
    }

    return hasValues
  }

  validateCancelDetail = (before, after) => {
    if (before.length !== after.length) return false

    return !isEqual(before, after)
  }

  onCancel = () => {
    const { form, id, currentDetail } = this.state
    const isValidate = id
      ? this.validateCancelDetail(currentDetail, form)
      : this.validateCancel(form)
    const redirectPath =
      this.props.location.state && this.props.location.state.from
        ? this.props.location.state.from
        : '/dash/stock-opname'

    if (isValidate) {
      const confirmCancel = window.confirm(
        'Are you sure you want to cancel the coal inventory?'
      )
      if (!confirmCancel) return
    }

    this.props.history.push(redirectPath)
  }

  onSubmit = async () => {
    const { toggleIsLoading } = this.props
    const { form } = this.state
    const errors = this.validateSubmit(form)
    if (errors.length) {
      alert('Please address the following issues:\n' + errors.join('\n'))
      return
    }

    try {
      toggleIsLoading(true)

      const { romLocation, status, ...restData } = form

      const mappingBody = {
        ...restData,
        ...(restData && { id: restData.id }),
        areaCode: restData.areaCode.code,
        period: moment(restData.period).format('YYYY-MM-DD'),
        surveyDate: moment(restData.surveyDate).format('YYYY-MM-DD'),
        totalTonnage: (() => {
          const total = restData.coalStockInventoryDetails.reduce(
            (sum, { tonnage }) =>
              sum + parseFloat(tonnage.toString().replace(/,/g, '') || 0),
            0
          )

          return total % 1 === 0 ? total : parseFloat(total.toFixed(4))
        })(),
        coalStockInventoryAttachments:
          restData.coalStockInventoryAttachments.map(
            ({ media, mimeType, file, fileId, id, ...rest }) => ({
              ...rest,
              ...(fileId && { id: id }),
              ...(!fileId && { base64: file }),
            })
          ),
        coalStockInventoryDetails: restData.coalStockInventoryDetails.map(
          ({ isNew, productCode, mode, id, ...rest }) => ({
            ...rest,
            ...(!isNew && { id: id }),
            dirLocationCode: rest.dirLocationCode.name,
            dirLocationSourceName: rest.dirLocationCode.sourceName,
            productName: productCode.name,
            startTime: moment(rest.startTime).format('HH:mm:ss'),
            endTime: moment(rest.endTime).format('HH:mm:ss'),
            tonnage: rest.tonnage.toString().replace(/,/g, ''),
            volume: rest.volume.toString().replace(/,/g, ''),
            factorScale: rest.factorScale.toString().replace(/,/g, ''),
          })
        ),
      }

      const res = await postNewData(`${COAl_STOCK_INVENTORIES}`, mappingBody)

      if (res.status < 400) {
        alert('Success!')
        const redirectPath =
          this.props.location.state && this.props.location.state.from
            ? this.props.location.state.from
            : '/dash/stock-opname'

        this.props.history.push(redirectPath)
      } else {
        const message = res.message
          ? res.message
          : `Failed to ${mappingBody.id ? 'edit' : 'submit'}`
        alert(message)
        throw res
      }
    } catch (error) {
      return
    } finally {
      toggleIsLoading(false)
    }
  }

  render() {
    const { loadingId, form, allowUpdate, id } = this.state
    const navList = [
      'Stock Opname',
      `${loadingId ? 'Edit' : 'Add'} Stock Opname`,
    ]
    const {
      viewState: { isMobileView },
    } = this.props

    return (
      <PageWrapper isMobile={isMobileView}>
        <Breadcrumb navList={navList} />
        <Header
          form={form}
          onChange={this.onChange}
          onChangeForm={this.onChangeForm}
          enableField={id ? allowUpdate : true}
        />
        <DetailCoalInventory
          form={form}
          onChange={this.onChange}
          onChangeForm={this.onChangeForm}
          enableField={id ? allowUpdate : true}
        />
        <Footer>
          <ButtonReg
            transparent
            btnTxt={'Cancel'}
            onClick={() => this.onCancel()}
            width={'150px'}
            margin="0 10px 0 0"
          />
          {(id ? allowUpdate : true) && (
            <ButtonReg
              btnTxt={'Save'}
              onClick={() => this.onSubmit()}
              width={'150px'}
            />
          )}
        </Footer>
      </PageWrapper>
    )
  }
}

const mapStateToProps = (state) => {
  return {
    userLogin: state.userLogin,
    viewState: state.viewState,
  }
}

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      toggleIsLoading,
      setLocalSettingsTableData,
      getAllDirLocationsData,
      getAllProductsData,
    },
    dispatch
  )

export default withRouter(
  withTheme(connect(mapStateToProps, mapDispatchToProps)(StockOpnameForm))
)
